"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAsyncData = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var DEFAULT_PARSER = function DEFAULT_PARSER(data) {
  return data;
};

var useAsyncData = function useAsyncData(asyncData) {
  var parseData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PARSER;
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  (0, _react.useEffect)(function () {
    var _ref = asyncData || {},
        isFetching = _ref.isFetching,
        isError = _ref.isError,
        userData = _ref.userData;

    var isSuccess = !(isError || isFetching);

    if (Boolean(userData) && isSuccess) {
      var resultingData = parseData(userData.data);
      setData(resultingData);
    }
  }, [asyncData]);
  return data;
};

exports.useAsyncData = useAsyncData;